import { useCallback, useEffect, useRef, useState } from 'react';

import * as S from './styles';

type VideoDescriptionProps = {
  text: string;
};

const VideoDescription = ({ text }: VideoDescriptionProps) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isClamped, setIsClamped] = useState(false);
  const ref = useRef<HTMLParagraphElement>(null);

  const checkClamped = useCallback(() => {
    const el = ref.current;
    if (el) {
      setIsClamped(el.scrollHeight > el.clientHeight);
    }
  }, []);

  useEffect(() => {
    checkClamped();
  }, [text, checkClamped]);

  const canToggle = isClamped || isExpanded;

  return (
    <S.DescriptionBlock
      onClick={() => canToggle && setIsExpanded((prev) => !prev)}
      style={{ cursor: canToggle ? 'pointer' : 'default' }}
    >
      <S.DescriptionText $expanded={isExpanded} ref={ref}>
        {text}
      </S.DescriptionText>
      {canToggle && (
        <S.ToggleButton>
          {isExpanded ? 'Mostrar menos ▴' : 'Mostrar mais ▾'}
        </S.ToggleButton>
      )}
    </S.DescriptionBlock>
  );
};

export default VideoDescription;
